<template>
  <main v-loading="load.page">
    <section class="allProductList">
      <figure>
        <search class="search" :noAnimation="true" @change="changeKeyword" />
        <!-- 筛选栏目 -->
        <nav>
          <el-select v-model="search.KindName" class="select" size="mini" :clearable="true" placeholder="签证类别">
            <el-option v-for="v in KindNames" :key="v" :label="v" :value="v">
            </el-option>
          </el-select>
          <el-select v-model="search.FormName" class="select" size="mini" :clearable="true" placeholder="签证形式">
            <el-option v-for="v in FormNames" :key="v" :label="v" :value="v">
            </el-option>
          </el-select>
        </nav>
      </figure>

      <!-- 左侧根据 签证类别 筛选后的产品列表 -->
      <ul v-loading="load.list" class="visaItemsList">
        <li :class="{ listItemActive: activeProductId === item.id }" v-for="item in getVisaList"
          :key="item.VisaProductID" @click="changeProduct(item)">
          <h3>
            <span>{{ item.visa_type_label }}</span><b>{{ item.list_title }}</b>
          </h3>
          <p>
            <time>办理<b>{{ item.fastest_processing_days }}</b>个工作日起</time>
            <strong>
              <span class="price">{{ item.starting_price }}</span>
            </strong>
          </p>
        </li>
      </ul>
    </section>

    <section class="productInfoSection" v-loading="load.detail">
      <header id="point0">
        <h2>{{ info.name }}</h2>
        <!-- 顶部标签模块 -->
        <div class="tag">
          <span v-for="v in info.serves" :key="v">{{ v }}</span>
        </div>
        <ul class="productOtherTags">
          <li v-for="(item, index) in timeList" :key="index">
            <span>{{ item.title }}</span><b>{{ item.val }}</b>
          </li>
          <li>
            <span>是否面签</span><b>{{ info.visa_need_interview_label }}</b>
          </li>
          <li>
            <span>是否打指模</span><b>{{ info.visa_need_fingerprinting_label }}</b>
          </li>
        </ul>

        <!-- 属性选择模块 -->
        <div class="attrGroup"
          v-if="customProcessingDateList && customProcessingDateList.length > 1 && sku_attributeList && sku_attributeList.length">
          <h3>属性选择</h3>

          <!-- 自定义 办理时长(所需工作日) -->
          <template v-if="customProcessingDateList && customProcessingDateList.length">
            <figure class="attrItem">
              <!-- <h4>办理时长(所需工作日)--自定义</h4> -->
              <h4>办理时长(所需工作日)</h4>
              <div class="skuChooseList">
                <figcaption class="sku_items" v-for="(item, index) in customProcessingDateList" :key="index"
                  :class="activedCustomProcessing == item ? 'activeItem' : ''"
                  @click="chooseCustomProcessingDate(item)">{{ item + '工' }}
                </figcaption>
              </div>
            </figure>
          </template>

          <figure class="attrItem" v-for="(item, i) in sku_attributeList" :key="i">
            <template
              v-if="item.sku_attribute_values && item.sku_attribute_values.length && item.sku_attribute_values.length > 1 && item.id != 73">
              <h4>{{ item.title }}</h4>
              <div class="skuChooseList">
                <figcaption :class="isSelectedAttr(item2.id) ? 'activeItem' : ''" class="sku_items"
                  v-for="item2 in item.sku_attribute_values" :key="item2.id" @click="chooseSkuAttr(item2)">{{
                    item2.attribute_value }}
                </figcaption>
              </div>
            </template>
          </figure>

        </div>

        <div class="meal">
          <h3>套餐选择</h3>
          <nav v-if="info.visa_prices">

            <!-- 无选择属性时 -->
            <template v-if="!selectedSkukList.length && Number(activedCustomProcessing) < 0">
              <b :class="{ on: item.id === selectedSku_Id }" class="skuItemWrap" v-for="(item, i) in sku_List"
                :key="item.id" @click="selectedSku(item, i)">
                <span class="skuListTitle">{{ item.list_title }}</span>
                <template v-if="item.visa_workdays_label">
                  <p class="predictDate">预计{{ item.visa_workdays_label }}出签</p>
                  <p class="earliestDate">(预计最早{{ getEarlyTravelDate(item.visa_processing_days) }}出发)</p>
                </template>
                <p v-if="item.visa_reminder" class="skuReminder">({{ item.visa_reminder }})</p>
              </b>
            </template>

            <!-- 有选择属性时的套餐列表 -->
            <template v-else>
              <template v-if="filtrateVisaProductList && filtrateVisaProductList.length">
                <b :class="{ on: item.id === selectedSku_Id }" class="skuItemWrap"
                  v-for="(item, i) in filtrateVisaProductList" :key="item.id" @click="selectedSku(item, i)">
                  <span class="skuListTitle">{{ item.list_title }}</span>
                  <template v-if="item.visa_workdays_label">
                    <p class="predictDate">预计{{ item.visa_workdays_label }}出签</p>
                    <p class="earliestDate">(最早{{ getEarlyTravelDate(item.visa_processing_days) }}出发)</p>
                  </template>
                  <p v-if="item.visa_reminder" class="skuReminder">({{ item.visa_reminder }})</p>
                </b>
              </template>
              <template v-else>
                <b class="nothingChoose">暂无可选套餐</b>
              </template>
            </template>

          </nav>

          <h3>出行日期和份数</h3>
          <div class="label">
            <el-date-picker type="date" ref="day" v-model="sku_travel_date" value-format="yyyy-MM-dd"
              :picker-options="dayOptions" placeholder="选择日期" @change="changeDatePicker">
            </el-date-picker>
            <el-input-number v-model="sku_quantity" :min="1" label="份数"></el-input-number>
          </div>
        </div>

        <div class="price">
          <div class="paymentType" v-if="selectedSku_Info && selectedSku_Info.dealer_price">
            结算方式 :
            <el-radio-group v-model="selectedPaymentType" class="radioGroupWrap">
              <el-radio label="1" border>分销商价</el-radio>
              <el-radio label="2" border>零售价</el-radio>
            </el-radio-group>
          </div>
          <p>
            <b>{{ getPrice }}</b>
            <span>{{ info.SupplierName }}</span>
          </p>
          <div class="btn" v-if="showCreateOrderStatus">
            <button @click="placeAnOrder">立即办理</button>
          </div>
        </div>

      </header>

      <ul class="time_lines">
        <li :class="{ on: getPointIndex === 1 }" v-if="info.description && info.description.description"
          @click="goPoint(1)">
          <span>产品详情</span>
        </li>
        <li :class="{ on: getPointIndex === 2 }" @click="goPoint(2)">
          <span>所需资料</span>
        </li>
        <template v-if="productInfo && productInfo.spu && productInfo.spu.spu_knowledge_content">
          <li :class="{ on: getPointIndex === 3 }" @click="goPoint(3)">
            <span>注意事项</span>
          </li>
        </template>
        <li :class="{ on: getPointIndex === 4 }" @click="goPoint(4)">
          <span>样板展示</span>
        </li>
      </ul>

      <section id="point1" v-if="info.description && info.description.description">
        <h3><span>产品详情</span></h3>
        <div class="nodes" v-html="info.description.description || '--'"></div>
      </section>

      <section id="point2">
        <h3 class="noBorder">
          <span>所需资料</span>
        </h3>
        <nav class="subTitle">
          <span :class="{ on: info.materialIndex === i }" v-for="(v, i) in info.filesByTraveler" :key="i"
            @click="changeMaterialIndex(i, v.length)">{{ v.text }}({{ v.files.length }})</span>
        </nav>
        <ul class="data" v-loading="changinformation">

          <li v-for="v in info.filesByTraveler_detail" :key="v.VisaFileID">
            <h5>{{ v.name }}</h5>
            <p v-html="v.description"></p>
            <a :style="{
              right: v.file_url && v.file_url !== 'NULL' ? '200px' : '',
            }" v-show="v.img_url && v.img_url !== 'NULL'" :download="v.Name"
              @click.stop="previewImage(v.img_url)">浏览资料</a>

            <a v-show="v.file_url && v.file_url !== 'NULL'" :href="v.file_url" :download="v.Name"
              target="_blank">下载资料</a>
          </li>
        </ul>
      </section>

      <section id="point3" v-if="productInfo && productInfo.spu && productInfo.spu.spu_knowledge_content">
        <h3><span>注意事项</span></h3>
        <div class="nodes" v-html="encodeHTML(productInfo.spu.spu_knowledge_content)"></div>
      </section>

      <section id="point4" v-show="info.visa_models">
        <h3><span>样板展示</span></h3>
        <div class="nodes">
          <template v-if="info.visa_models && info.visa_models.length">
            <img v-for="v in info.visa_models" :key="v.VisaModelID" :src="v.img_url" alt=""
              @click.stop="previewImage(v.img_url)" />
          </template>
          <template v-else>暂无样板</template>
        </div>
      </section>
    </section>


    <ul class="floatNavigation" :class="{ hide: !showFloatNavigation }">
      <li :class="{ on: getPointIndex === 1 }" @click="goPoint(1)"
        v-if="info.description && info.description.description">
        <span>产品详情</span>
      </li>
      <li :class="{ on: getPointIndex === 2 }" @click="goPoint(2)">
        <span>所需资料</span>
      </li>
      <template v-if="productInfo && productInfo.spu && productInfo.spu.spu_knowledge_content">
        <li :class="{ on: getPointIndex === 3 }" @click="goPoint(3)">
          <span>注意事项</span>
        </li>
      </template>

      <li :class="{ on: getPointIndex === 4 }" @click="goPoint(4)">
        <span>样板展示</span>
      </li>
      <li class="noBefore" v-if="showCreateOrderStatus">
        <el-button type="danger" @click="goPoint(0)">立即办理</el-button>
      </li>
    </ul>

  </main>
</template>

<script>
import search from "@components/search";
import $visa from "@api/visa";
import $user from "@api/user";
import moment from "moment";
import { mapState, mapMutations } from "vuex";
import tool from '@assets/js/tool';
import day from '@assets/js/day';

export default {
  components: {
    search,
  },

  data() {
    return {
      productInfo: {},
      timeList: [],
      value1: '',
      activeProductId: '',
      selectedSku_Info: null,
      selectedSku_Id: '',
      showCreateOrderStatus: true,
      sku_List: [],
      sku_travel_date: null,
      sku_quantity: 1,
      info: {
        material: [],
        materialIndex: 0,
        meal: null,
        day: null,
        count: 1,
      },
      list: [],
      load: {
        list: false,
        detail: false,
        page: true,
      },
      FormNames: [],
      KindNames: [],
      search: {
        FormName: null,
        KindName: null,
        infoIndex: 0,
        productID: '',
      },
      dayOptions: {
        disabledDate: (date) => {
          if (!this.selectedSku_Id) return null;
          const activeSkuItem = this.activeSkuItem;
          if (!activeSkuItem || !activeSkuItem.visa_processing_days) return null;
          const addDay = ~~activeSkuItem.visa_processing_days;
          const targetStartDate = tool.getDateAfterWorkingDays(moment().format('YYYY-MM-DD'), Number(addDay));
          return Date.parse(targetStartDate) > Date.parse(date);
        },
      },
      scrollTop: 0,
      scrollVal: [],
      isClick: true,
      sku_attributeList: [],
      selectedSkukList: [],
      countryHolidayList: [],
      selectedPaymentType: '1',
      changinformation: false,
      customProcessingDateList: [],
      activedCustomProcessing: -1,
      timeLinesTop: 0,
      sku_attribute_value: [],
    };
  },
  watch: {
    selectedSku_Id: {
      handler(newVal) {
        if (newVal) {
          const activeSkuItem = this.sku_List.find((item) => item.id === newVal);
          if (activeSkuItem && Object.keys(activeSkuItem).length) {
            this.selectedSku_Info = activeSkuItem;
          }
        }
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    // activeSkuItem计算属性：获取当前选中的套餐对象
    activeSkuItem() {
      return this.sku_List.find((item) => item.id === this.selectedSku_Id) || {};
    },
    // getPrice计算属性：计算当前选中的总价
    getPrice() {
      if (!this.selectedSku_Id) return 0;
      let addUpPrice = 0;
      const activeSkuItem = this.activeSkuItem;
      if (activeSkuItem && Object.keys(activeSkuItem).length) {
        let unitPrices = 0;
        const hasDealerPriceList = ['distribution', 'staff', 'partner'];
        if (this.userInfo && this.userInfo.identify && hasDealerPriceList.includes(this.userInfo.identify)) {
          unitPrices = this.selectedPaymentType === "1" ? Number(activeSkuItem.dealer_price) : Number(activeSkuItem.retail_price);
        } else {
          unitPrices = Number(activeSkuItem.retail_price) || 0;
        }
        addUpPrice = Number(unitPrices * this.sku_quantity).toFixed(2);
      }
      return addUpPrice || 0;
    },
    // getVisaList计算属性：获取左侧产品列表，并根据筛选条件过滤
    getVisaList() {
      const { list } = this;
      const { FormName, KindName } = this.search;
      let filterList = JSON.parse(JSON.stringify(list));

      filterList.forEach((item) => {
        item.starting_price = item.first_dealer_price ? this.setNormalPrice(item.first_dealer_price) : this.setNormalPrice(item.first_price);
      });

      return filterList.filter((v) => {
        if (Boolean(FormName) !== false && v.visa_form_label !== FormName) {
          return false;
        }
        if (Boolean(KindName) !== false && v.visa_type_label !== KindName) {
          return false;
        }
        return true;
      });
    },
    // getPointIndex计算属性：获取当前滚动到的锚点索引
    getPointIndex() {
      const list = this.scrollVal;
      const i = list.findIndex((v) => this.scrollTop < v) - 1;
      return i < 0 ? (this.scrollTop > 100 ? list.length - 1 : 0) : i;
    },
    // filtrateVisaProductList计算属性：根据已选属性和办理时长筛选套餐
    filtrateVisaProductList() {
      let filterList = [];
      let productList = JSON.parse(JSON.stringify(this.info.visa_prices || []));
      let selectedAttrbuiteIdList = this.selectedSkukList.map((item) => item.id);

      if (!productList.length) {
        this.showCreateOrderStatus = false;
        return [];
      }

      if (selectedAttrbuiteIdList.length) {
        if (selectedAttrbuiteIdList.length === 1) {
          productList.forEach((item) => {
            if (item.attribute_value_ids.includes(selectedAttrbuiteIdList[0])) {
              filterList.push(item);
            }
          });
        } else {
          productList.forEach((item) => {
            if (this.getSameAttrLength(item.attribute_value_ids, selectedAttrbuiteIdList) >= selectedAttrbuiteIdList.length) {
              filterList.push(item);
            }
          });
        }
      } else {
        filterList = productList;
      }

      if (Number(this.activedCustomProcessing) >= 0) {
        filterList = filterList.filter((item) => item.visa_processing_days === this.activedCustomProcessing);
      }

      this.selectedSku_Id = filterList.length ? filterList[0]['id'] : '';
      this.showCreateOrderStatus = filterList.length > 0;

      return filterList;
    },
    // showFloatNavigation计算属性：判断是否显示浮动导航
    showFloatNavigation() {
      return this.timeLinesTop <= 80;
    }
  },
  filters: {
    getMaterialName(i) {
      const arr = ["在职人员", "退休", "自由职业", "学生", "学龄前儿童"];
      return arr[i];
    },
  },
  async created() {
    // created生命周期：检测登录状态、初始化产品列表
    try {
      const res = await $user.checkLogin();
      if ("success" in res) {
        this.updateUserInfo(res);
      } else {
        if (this.userInfo) {
          const localUserSecret = localStorage.getItem('privacyInfo');
          if (localUserSecret) {
            const secretInfo = JSON.parse(localUserSecret);
            const loginRes = await $user.login(secretInfo);
            if (!loginRes.error) {
              this.updateUserInfo(loginRes);
            }
          }
        }
      }
    } catch (e) {
      console.warn('登录检测失败', e);
    }

    const { id, detailId, pdid, spu_id } = this.$route.query;
    if (spu_id) {
      this.activeProductId = Number(spu_id);
    }
    this.getList(id, detailId, pdid);

    window.addEventListener("scroll", this.scrollFun, true);
    this.updateTimeLinesRect();
    window.addEventListener('scroll', this.updateTimeLinesRect, true);
    window.addEventListener('resize', this.updateTimeLinesRect);
  },
  methods: {
    ...mapMutations(['updateUserInfo']),
    // 预览图片
    previewImage(url) {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'ico'];
      const ext = url.split('?')[0].split('.').pop().toLowerCase();
      if (imageExtensions.includes(ext)) {
        this.$viewerApi({ images: [url] });
      } else {
        window.open(url, '_blank');
      }
    },
    // updateTimeLinesRect函数：获取.time_lines元素到视口顶部的距离
    updateTimeLinesRect() {
      const el = document.querySelector('.time_lines');
      if (el) {
        const rect = el.getBoundingClientRect();
        this.timeLinesTop = rect.top;
      }
    },

    // chooseCustomProcessingDate函数：选择/取消自定义办理时长
    chooseCustomProcessingDate(item) {
      if (this.activedCustomProcessing === item) {
        this.activedCustomProcessing = -1;
      } else {
        this.activedCustomProcessing = item;
      }
    },

    // encodeHTML函数：将HTML实体字符转换为原始字符
    encodeHTML(str) {
      const arrEntities = {
        'lt': '<',
        'gt': '>',
        'nbsp': ' ',
        'amp': '&',
        'quot': '"'
      };
      return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) {
        return arrEntities[t];
      });
    },

    // getAttrValueById函数：根据属性ID从属性列表中获取属性值
    getAttrValueById(data, id) {
      const attrObj = data.find((item) => item.attribute_id === id) || {};
      let finalValue = '';
      if (Object.values(attrObj).length) {
        const attrId = attrObj.attribute_value_id || '';
        const targets = this.sku_attribute_value.find((item) => item.id === id);
        if (attrId && targets) {
          const finalObj = targets.sku_attribute_values.find((item) => item.id === attrId) || {};
          if (Object.keys(finalObj).length) {
            finalValue = finalObj.attribute_value;
          }
        }
      }
      return finalValue;
    },

    // getTopInfoBySelectedSku函数：根据选中的SKU获取顶部展示信息（有效期、停留、入境次数）
    getTopInfoBySelectedSku(data) {
      const attrList = data.attrs;
      const validityInfo = this.getAttrValueById(attrList, 112) || this.productInfo.spu.visa_expiry_date;
      const durationInfo = this.getAttrValueById(attrList, 111) || this.productInfo.spu.visa_stay_days;
      const entriesTimesInfo = this.getAttrValueById(attrList, 110) || this.productInfo.spu.visa_entries;

      this.timeList = [
        { title: '有效期限', val: validityInfo },
        { title: '最长停留', val: durationInfo },
        { title: '入境次数', val: entriesTimesInfo }
      ];
    },

    // getEarlyTravelDate函数：根据办理天数计算最早可出行日期
    getEarlyTravelDate(day) {
      return tool.getDateAfterWorkingDaysWithHolidays(day, this.countryHolidayList);
    },

    // changeDatePicker函数：日期选择变更时的校验
    changeDatePicker(e) {
      const activeSkuItem = this.activeSkuItem;
      if (!activeSkuItem || !activeSkuItem.visa_processing_days) {
        this.sku_travel_date = null;
        return;
      }
      const addDay = ~~activeSkuItem.visa_processing_days;
      const targetStartDate = tool.getDateAfterWorkingDays(moment().format('YYYY-MM-DD'), Number(addDay));
      if (e < targetStartDate) {
        this.sku_travel_date = null;
      } else {
        this.sku_travel_date = e;
      }
    },

    // selectedSku函数：选择套餐
    selectedSku(item) {
      this.selectedSku_Id = item.id;
      this.sku_travel_date = null;
      this.sku_quantity = 1;
      this.getTopInfoBySelectedSku(item);
    },

    // getAfterFilterList函数：获取筛选后的套餐列表（此方法已不再使用，保留以保证兼容）
    getAfterFilterList() {
      let filterList = [];
      let productList = this.info.visa_prices || [];
      if (!productList.length) {
        this.showCreateOrderStatus = false;
        return [];
      }
      let selectedAttrbuiteIdList = this.selectedSkukList.map((item) => item.id);

      if (selectedAttrbuiteIdList.length) {
        if (selectedAttrbuiteIdList.length === 1) {
          productList.forEach((item) => {
            if (item.attribute_value_ids.includes(selectedAttrbuiteIdList[0])) {
              filterList.push(item);
            }
          });
        } else {
          productList.forEach((item) => {
            if (this.getSameAttrLength(item.attribute_value_ids, selectedAttrbuiteIdList) >= selectedAttrbuiteIdList.length) {
              filterList.push(item);
            }
          });
        }
      } else {
        filterList = productList;
      }

      if (!filterList.length) {
        this.showCreateOrderStatus = false;
      } else {
        this.showCreateOrderStatus = true;
      }
      return filterList;
    },

    // getSameAttrLength函数：计算两个数组中相同元素的个数
    getSameAttrLength(arr1, arr2) {
      let sameNum = 0;
      arr1.forEach((item) => {
        if (arr2.includes(item)) {
          sameNum += 1;
        }
      });
      return sameNum;
    },

    // isSelectedAttr函数：判断某个属性是否已被选中
    isSelectedAttr(attrId) {
      return this.selectedSkukList.some((item) => item.id === attrId);
    },

    // chooseSkuAttr函数：选择/取消属性
    chooseSkuAttr(param) {
      const { id, attribute_id } = param;
      this.sku_travel_date = null;
      this.sku_quantity = 1;

      const isIncludesItem = this.selectedSkukList.find((item) => item.attribute_id === attribute_id);

      if (!isIncludesItem) {
        this.selectedSkukList.push(param);
      } else {
        const index = this.selectedSkukList.findIndex((item) => item.attribute_id === attribute_id);
        if (this.selectedSkukList[index].id === id) {
          this.selectedSkukList.splice(index, 1);
        } else {
          this.selectedSkukList.splice(index, 1, param);
        }
      }
    },

    // setNormalPrice函数：格式化价格显示
    setNormalPrice(price) {
      return tool.ConversionPrice(price);
    },

    // placeAnOrder函数：提交订单跳转
    placeAnOrder() {
      if (!this.sku_travel_date) {
        this.$message.warning("请选择出行日期！");
        this.$refs.day.focus();
        return;
      }
      if (!this.sku_quantity) {
        this.$message.warning("请选择购买数量！");
        return;
      }
      if (!this.selectedSku_Id) {
        this.$message.warning("请选择套餐！");
        return;
      }

      const orderInfo = this.sku_List.find((item) => item.id === this.selectedSku_Id);
      const pageParams = {
        order: orderInfo,
        day: this.sku_travel_date,
        count: this.sku_quantity,
        info: this.info
      };
      this.$router.push({
        name: "order_add",
        params: pageParams
      });
    },

    // getList函数：获取左侧产品列表
    async getList(id, detailId, pdid) {
      this.toggleLoad("list");
      try {
        const holidayRes = await $visa.getHolidayByCountryId(id);
        this.countryHolidayList = Object.keys(holidayRes).length ? holidayRes.data : [];

        const res = await $visa.getVisaProductList(id);
        const orginalParam = this.$route.query;
        if (orginalParam.spu_id) {
          this.activeProductId = Number(orginalParam.spu_id);
          this.$router.push({ path: "./visa_list", query: { ...orginalParam, spu_id: orginalParam.spu_id } });
        } else {
          this.activeProductId = res.data.products[0]['id'];
          this.$router.push({ path: "./visa_list", query: { ...orginalParam, spu_id: this.activeProductId } });
        }

        const visa_type_option = res.data.products.reduce((item, v) => {
          !item.includes(v.visa_type_label) && item.push(v.visa_type_label);
          return item;
        }, []);

        const visa_form_option = res.data.products.reduce((item, v) => {
          !item.includes(v.visa_form_label) && item.push(v.visa_form_label);
          return item;
        }, []);

        if (pdid) {
          const infoIndex = res.data.products.findIndex((v) => v.id === Number(pdid));
          this.search = { ...this.search, infoIndex };
        }

        this.list = res.data.products;
        this.KindNames = visa_type_option;
        this.FormNames = visa_form_option;
        this.clearSearch();
        this.getDetail();
        this.toggleLoad("list");
        if (this.load.page) {
          this.load = { ...this.load, page: false };
        }
      } catch (e) {
        console.warn('获取产品列表失败', e);
        this.toggleLoad("list");
      }
    },

    // getCustomProcessingData函数：获取所有SKU的办理时长并去重排序
    getCustomProcessingData(data) {
      let visa_processing_daysList = data.map((item) => item.visa_processing_days);
      visa_processing_daysList = [...new Set(visa_processing_daysList)].sort((a, b) => a - b);
      this.customProcessingDateList = visa_processing_daysList;
    },

    // getDetail函数：获取产品详情
    async getDetail() {
      this.toggleLoad("detail");
      const id = this.activeProductId || this.list[0]?.id;
      if (!id) {
        this.toggleLoad("detail");
        return;
      }

      try {
        const res = await $visa.getVisaProductDetail(id);
        this.productInfo = res.data;
        this.sku_attribute_value = res.data.sku_attribute_value;

        this.getCustomProcessingData(res.data.skus);
        this.getTopInfoBySelectedSku(res.data.skus[0]);

        let info = res.data.spu;
        info.starting_price = this.setNormalPrice(info.starting_price);

        let skus = res.data.skus || [];
        if (!skus.length) {
          this.toggleLoad("detail");
          this.sku_List = [];
          this.sku_attributeList = [];
          return;
        }

        skus.forEach((item) => {
          item.retail_price = item.retail_price ? this.setNormalPrice(item.retail_price) : 0;
          item.dealer_price = item.dealer_price ? this.setNormalPrice(item.dealer_price) : 0;
        });

        this.sku_List = skus;
        info.visa_prices = skus;
        this.selectedSku_Id = skus[0]['id'];
        this.sku_attributeList = res.data.sku_attribute_value;

        info.filesByTraveler_detail = info.filesByTraveler && info.filesByTraveler[0] ? info.filesByTraveler[0].files : {};

        if (info.Promise) {
          info.serves = info.Promise.split(",").filter((v) => !!v);
        } else {
          info.serves = [];
        }

        const material = info.filesByTraveler.map((item) => item.files);
        info.material = material;
        info.materialIndex = 0;

        this.info = info;
        this.setTitle(info.name);
        this.scrollTo();
        setTimeout(this.getPointY, 300);
        this.toggleLoad("detail");
      } catch (e) {
        console.warn('获取产品详情失败', e);
        this.toggleLoad("detail");
      }
    },

    // toggleLoad函数：切换加载状态
    toggleLoad(attr) {
      this.load = { ...this.load, [attr]: !this.load[attr] };
    },

    // clearSearch函数：清空筛选条件
    clearSearch() {
      this.search = { ...this.search, KindName: null, FormName: null };
    },

    // changeKeyword函数：搜索关键词变更后重新加载列表
    changeKeyword({ id }) {
      this.getList(id);
    },

    // changeSearch函数：筛选条件变更（目前未使用，保留）
    changeSearch(attr, value) {
      this.search = { ...this.search, [attr]: value };
    },

    // changeMaterialIndex函数：切换所需资料选项卡
    changeMaterialIndex(i, len) {
      if (len === 0) return;
      this.changinformation = true;
      setTimeout(() => {
        this.info = { ...this.info, materialIndex: i };
        this.info.filesByTraveler_detail = this.info.filesByTraveler[i].files;
        this.changinformation = false;
      }, 300);
    },

    // scrollFun函数：滚动事件监听，记录滚动位置
    scrollFun() {
      this.scrollTop = document.documentElement.scrollTop;
    },

    // goPoint函数：滚动到指定锚点
    goPoint(i) {
      const el = document.querySelector(`#point${i}`);
      if (el) {
        this.scrollTo(el.offsetTop - 60);
      }
    },

    // getPointY函数：获取所有锚点的位置
    getPointY() {
      const arr = [...new Array(5)].map((v, i) => {
        const obj = document.querySelector(`#point${i}`);
        return obj ? obj.offsetTop : 0;
      });
      this.scrollVal = arr;
    },

    // changeProduct函数：切换左侧产品
    changeProduct(detailInfo) {
      const currentProductId = detailInfo.id;
      const orginalParam = this.$route.query;
      this.$router.push({ path: "./visa_list", query: { ...orginalParam, spu_id: currentProductId } });

      if (this.activeProductId !== currentProductId) {
        this.activeProductId = currentProductId;
        this.getDetail();
      }
      this.selectedSkukList = [];
      this.sku_quantity = 1;
      this.sku_travel_date = null;
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollFun);
    window.removeEventListener('scroll', this.updateTimeLinesRect, true);
    window.removeEventListener('resize', this.updateTimeLinesRect);
  },
};
</script>

<style scoped src="./list2.css"></style>
<style scope>
.nodes strong {
  font-weight: bold;
}
</style>